import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, CustomerService } from '../_services';
import { Observable } from 'rxjs';
import { DataService } from '../_helpers/dataservice.service'

@Component({
  selector: 'header-menu',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  accessTokenObj: any;
  isLoggedin: any;
  isReloaded: any;
  profile: any;
  profilePicture: any;
  accessToken: any;
  customerName: any;
  isCorporate: any = false;
  isCorporateCompany: any;
  isLogoClicked = true;

  @Input() eventsProfilePhoto: Observable<void>;

  constructor(
    private authService: AuthService
    , private router: Router
    , private dataService: DataService
    , private customerService: CustomerService
  ) {
    this.authService.getLoggedInStatus.subscribe(retstatus => {
      this.isLoggedin = retstatus;
    });
  }

  ngOnInit() {
    setTimeout(() => {
      if (this.authService.isAuthenticated) {

        this.accessToken = localStorage.getItem('access_token');
        this.profilePicture = localStorage.getItem('userPhoto');
        this.customerName = localStorage.getItem('customername');
        this.isCorporate = (localStorage.getItem('isCorporate') == 'undefined') ? false : true;

        if (this.accessToken != null && this.accessToken !== undefined) {

          if (this.authService.userProfile) {

            this.profile = this.authService.userProfile;
            this.isLoggedin = true;
            this.profile = localStorage.getItem('auth0profile');
            var obj = JSON.parse(this.profile);
            this.profilePicture = obj.picture;
            this.customerName = localStorage.getItem('customername');

          } else {

            this.authService.getProfile((err, profile) => {
              this.isLoggedin = true;
              this.profile = localStorage.getItem('auth0profile');
              var obj1 = JSON.parse(this.profile);
              this.profilePicture = obj1.picture;

            });
          }
        }
      }

      this.dataService.currentUserProfilePhoto.subscribe(photourl => this.profilePicture = photourl);
      this.dataService.currentUserProfileName.subscribe(customerName => this.customerName = customerName);

      this.customerName = localStorage.getItem('customername');
    }, 2000)
  }

  updateUrl() {
    this.profilePicture = localStorage.getItem('userPhoto');
    this.customerName = localStorage.getItem('customername');
    this.isCorporate = (localStorage.getItem('isCorporate') == 'undefined') ? false : true;
  }

  onLogout() {
    sessionStorage.removeItem('isSessionNew')
    localStorage.setItem('isLoggedout', "true");
    this.authService.logout();
  }

  logo() {
    if (this.isLogoClicked == true) {
      this.isLogoClicked = false;
      this.isCorporateCompany = localStorage.getItem('isCorporateCompany');
      if (this.isCorporate == true && this.isCorporateCompany == "Yes") {
        this.router.navigate(['/companiescallback']);
      }
      if (this.isCorporate == true && this.isCorporateCompany == null) {
        this.router.navigate(['/companies']);
      }
      if (!this.isCorporate) {
        const application = localStorage.getItem('application');
        this.authService.loginGrantsCheck(application);
      }
    }
    setTimeout(() => {
      this.isLogoClicked = true;
    },2000);
  }

}
